export default __webpack_public_path__ + "static/media/wavecard.ea0deab6.svg";